import React from 'react';
import { Box, Pagination, PaginationItem } from '@mui/material';

export default function BlogPagination({ page, totalPages, onChange }) {
  return (
    <Box display="flex" justifyContent="center" mt={6}>
      <Pagination
        count={totalPages}
        page={page}
        onChange={(_, value) => onChange(value)}
        variant="outlined"
        shape="rounded"
        showFirstButton
        showLastButton
        siblingCount={1}
        boundaryCount={1}
        renderItem={(item) => (
          <PaginationItem
            {...item}
            sx={{
              // base styling for every bullet
              borderRadius: 2,
              minWidth: 40,
              marginX: 0.5,

              // override for the active bullet
              '&.Mui-selected': {
                bgcolor: 'primary.main',
                color: 'white',
                fontWeight: 'bold',
                borderColor: 'primary.main',
                '&:hover': {
                  bgcolor: 'primary.dark',
                },
              },

              // hover state
              '&:hover': {
                bgcolor: 'primary.light',
                borderColor: 'primary.light',
              },
            }}
          />
        )}
      />
    </Box>
  );
}
